import * as $echarts from "echarts";
import { specialStyle } from "@/assets/utils/specialStyle";
import * as size from "../utils/chartSize";

const commonRadarCharts = function (params) {
    const chartSizeA = specialStyle(document.body.clientHeight, 12)
    const chartSizeB = specialStyle(document.body.clientHeight, 14)
    const chartSizeC = specialStyle(document.body.clientHeight, 16)
    const chartSizeD = specialStyle(document.body.clientHeight, 18)
    const chartSizeE = specialStyle(document.body.clientHeight, 20)
    const chartSizeF = specialStyle(document.body.clientHeight, 22)
    const chartSizeG = specialStyle(document.body.clientHeight, 24)
    const chartSizeH = specialStyle(document.body.clientHeight, 28)
    const chartSizeI = specialStyle(document.body.clientHeight, 30)
    const chartSizeJ = specialStyle(document.body.clientHeight, 40)
    const chartSizeK = specialStyle(document.body.clientHeight, 50)
    // 特殊
    const chartSizeL = specialStyle(document.body.clientHeight, 4)
    const chartSizeM = specialStyle(document.body.clientHeight, 6)
    const chartSizeN = specialStyle(document.body.clientHeight, 10)

    // 绘制图表
    let option = {
        // legend: {
        //     data: params.legend,
        //     top: chartSizeL,
        //     left: chartSizeB,
        //     orient: 'vertical',
        //     itemGap: chartSizeM,
        //     itemWidth: chartSizeC,
        //     itemHeight: chartSizeN,
        //     textStyle: {
        //         color: '#fff',
        //         fontSize: chartSizeB,
        //         fontWeight: 400,
        //         fontFamily: 'Microsoft YaHei',
        //     },
        //     inactiveColor: '#ccc', // 图例关闭时的颜色
        // },
        grid: {
            left: chartSizeJ,
            top: chartSizeJ,
            bottom: chartSizeI,
            right: chartSizeE,
        },
        radar: {
            indicator: [
                { name: '分条机', max: 1 },
                { name: '焊机', max: 1 },
                { name: '终焊机', max: 1 },
                { name: '搅拌机', max: 1 },
                { name: '料机', max: 1 },
            ],
            center: ['50%', '56%'],//统计图位置，示例是居中
            radius: '78%',//统计图大小
            startAngle: 90,//统计图起始的角度
            splitNumber: 3,//统计图蛛网的网格分段，示例分为三段
            nameGap: chartSizeB,
            name: {
                formatter: '{value}',//蛛网轴尖的数据名称
                textStyle: {//蛛网轴尖的文字样式
                    fontWeight: 600,
                    fontSize: chartSizeD, //外圈标签字体大小
                    fontFamily: 'Microsoft YaHei',
                    color: '#FFFFFF', //外圈标签字体颜色
                }
            },
            splitArea: { // 蛛网在 grid 区域中的分隔区域，默认不显示。
                show: true,
                areaStyle: { // 分隔区域的样式设置。
                    color: ['rgba(76, 140, 200, 0.1)', 'rgba(76, 140, 200, 0.1)'], // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
                }
            },
            axisLine: { //蛛网轴线上的颜色，由内向外发散的那条
                lineStyle: {
                    color: 'rgba(116,143,189,0.5)',
                    fontSize: chartSizeG
                }
            },
            splitLine: {//蛛网环形的线条颜色
                lineStyle: {
                    color: 'rgba(116,143,189,0.5)', // 分隔线颜色
                    width: 1, // 分隔线线宽
                }
            }
        },
        series: [{
            type: 'radar',
            data: [{
                value: params.series.data,
                symbol: "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAUklEQVQYlX2PsQ2AMBADjwzAFihZ/hdA7BQF0R/NiwbCSW5sFzYq6qaGOlKRHqhV7b7paiXbM2JRB7DyzVUmwUMBjp98R20/Ixt5s+bYMxXpcQMIWpis7E/8kwAAAABJRU5ErkJggg==",
                symbolSize: chartSizeM,
                lineStyle: {
                    width: 2,
                    color: '#F7B500',
                },
                areaStyle: {
                    color: {
                        // x:右 , y: 下, x2: 左, y2: 上
                        x: 0, y: 0.5, x2: 1, y2: 1,
                        colorStops: [{
                            offset: 0, color: 'rgba(247,181,0,0.5)'
                        }, {
                            offset: 0.5, color: 'rgba(0,0,0,0)'
                        }, {
                            offset: 1, color: 'rgba(247,181,0,0.5)'
                        }],
                        global: false
                    },
                    opacity: 1 // 区域透明度
                }
            }]
        }]
    }
    params.id.setOption(option, true)
}

export {
    commonRadarCharts,
}